<template>
    <cadastro-simples-list
        endpoint="motivo-aula-compensada"
        rota-base="/admin/motivo-aula-compensada"
        titulo="Motivos de Aula Compensada (A.C)"
        titulo-singular="Motivo de A.C"
        :colunas-extras='[
            { campo: "descricao", label: "Descrição", tipo: "string" }
        ]'>
    </cadastro-simples-list>
</template>

<script>
import CadastroSimplesList from '@/components/cadastros-auxiliares/cadastro-simples-list.vue'
export default { components: { CadastroSimplesList } }
</script>
